/**
 * Раздел «Договоры». Пустое состояние живёт ЗДЕСЬ, а не под списком поездок: раньше строка
 * «Договоров пока нет» показывалась турагентству под его поездками и читалась как ошибка.
 */
import { useQuery } from '@tanstack/react-query'
import { useRouter } from 'expo-router'
import { Stack, Text, XStack, YStack } from 'tamagui'

import { api, type CabinetContract } from '../../../src/api/client'
import { CabinetShell } from '../../../src/features/cabinet/CabinetShell'
import { StateBadge } from '../../../src/features/cabinet/StateBadge'
import { useApp } from '../../../src/i18n'
import { Card, Icon, PressCard, QueryState, SkeletonLines } from '../../../src/ui'

function ContractRow({ row, onPress }: { row: CabinetContract; onPress: () => void }) {
  return (
    <PressCard onPress={onPress} padding={14}>
      <XStack gap={12} alignItems="center">
        <YStack flex={1} gap={4}>
          <Text fontSize={14} fontWeight="600" color="$color">
            {row.title || `№ ${row.number}`}
          </Text>
          {!!row.subject && (
            <Text fontSize={12} color="$muted" numberOfLines={2}>
              {row.subject}
            </Text>
          )}
        </YStack>
        <YStack alignItems="flex-end" gap={4}>
          <StateBadge state={row.state} />
          {row.amount !== undefined && (
            <Text fontSize={12} color="$muted">
              {row.amount} {row.currency ?? ''}
            </Text>
          )}
        </YStack>
      </XStack>
    </PressCard>
  )
}

export default function CabinetContractsScreen() {
  const { l } = useApp()
  const router = useRouter()
  const q = useQuery({ queryKey: ['cabinet', 'contracts'], queryFn: api.cabinetContracts })
  const rows = q.data ?? []

  return (
    <CabinetShell section="contracts">
      <YStack gap={6}>
        <Text fontSize={26} fontWeight="800" color="$color" letterSpacing={-0.4}>
          {l('cab.nav.contracts')}
        </Text>
        <Text fontSize={14} color="$muted">
          {l('cab.contracts.subtitle')}
        </Text>
      </YStack>
      <QueryState q={q}>
        {q.isLoading ? (
          <SkeletonLines lines={3} />
        ) : rows.length === 0 ? (
          <Card alignItems="center" gap={10} padding={40} borderStyle="dashed">
            <Stack
              width={48}
              height={48}
              borderRadius={12}
              backgroundColor="$primaryBg"
              alignItems="center"
              justifyContent="center"
            >
              <Icon name="file-text" size={24} color="$primary" />
            </Stack>
            <Text fontSize={16} fontWeight="700" color="$color">
              {l('cab.contracts.emptyTitle')}
            </Text>
            <Text fontSize={14} color="$muted" textAlign="center" maxWidth={440}>
              {l('cab.contracts.emptyText')}
            </Text>
          </Card>
        ) : (
          <YStack gap={10}>
            {rows.map((row) => (
              <ContractRow
                key={row.id}
                row={row}
                onPress={() => router.push(`/cabinet/contracts/${row.id}`)}
              />
            ))}
          </YStack>
        )}
      </QueryState>
    </CabinetShell>
  )
}
